import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SECURITY_ENDPOINTS } from "../../components/security/security-endpoints";
import { environment } from "../../../environments/environment";
import { ResetPassword } from "../../utils/interfaces/security/reset-password.interface";

@Injectable({
    providedIn: "root",
})
export class RecoveryRequestService {
    private baseUrl = SECURITY_ENDPOINTS.recoveryRequest;
    private isTokenValidUrl = SECURITY_ENDPOINTS.isTokenValid;
    private resetPasswordUrl = SECURITY_ENDPOINTS.resetPassword;

    constructor(private http: HttpClient) {}

    sendRecoveryRequest(email: string) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json",
            apiKey: environment.apiKey,
        });
        return this.http.post(
            this.baseUrl,
            { email, hostname: window.location.hostname },
            { headers }
        );
    }

    verifyToken(token: string) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json",
            apiKey: environment.apiKey,
        });
        return this.http.post(this.isTokenValidUrl, { token }, { headers });
    }

    resetPassword(body: ResetPassword) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json",
            apiKey: environment.apiKey,
        });
        return this.http.post(this.resetPasswordUrl, body, { headers });
    }
}
